<template>
    <div class="col-sm-3 mt-3">
            <label>Choose a place</label>
            <select
              name="cust-select"
              class="form-control m-1 float-right"
              v-model="plc"
              @click="sendPlc(plc)"
            >
              <option>Bengaluru</option>
              <option>Delhi</option>
              <option>Mumbai</option>
              <option>Mysore</option>
              <option>Mandya</option>
            </select>
          </div>
</template>

<script>
export default {
data(){
    return {
        plc : this.$route.query.ip || ''
    }
},
methods :{
sendPlc(plc){
    if(plc)
    this.$emit("sendPlace",plc);
}
}
}
</script>

<style scoped>
.form-control {
    display: block;
    width: 100%;
    padding: .375rem .75rem;
    font-size: 0.9rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 2px solid #17a2b8;
    border-radius: .25rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
</style>